import * as React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import { AlertTitle, SxProps, Typography, capitalize } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface ImportAlertProps {
  onClose?: () => void;
  severity: "success" | "info" | "warning" | "error";
  title?: string;
  paragraphs: string[];
  disableClose?: boolean;
  sx?: SxProps;
}

export default function TraxeroAlert({
  onClose,
  severity,
  title,
  paragraphs,
  disableClose = false,
  sx,
}: ImportAlertProps) {
  const [open, setOpen] = React.useState(true);
  const { t } = useTranslation();

  const handleClose = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Collapse in={open}>
        <Alert
          severity={severity}
          variant="outlined"
          sx={{ ...sx }}
          action={
            !disableClose && (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleClose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            )
          }
        >
          {title && (
            <AlertTitle sx={{ fontSize: 24 }}>
              <Typography
                variant="body1"
                component={"p"}
                fontWeight={"bold"}
                gutterBottom
              >
                {capitalize(t(title, { ns: "importWizard" }))}
              </Typography>
            </AlertTitle>
          )}
          {paragraphs.map((paragraph, index) => (
            <Typography key={index} variant="body2" component={"p"} pb={2}>
              {t(paragraph, { ns: "importWizard" })}
            </Typography>
          ))}
        </Alert>
      </Collapse>
    </Box>
  );
}
